//Bootstrap component list: Alert, BaseComponent, Button, Carousel, Collapse, Dropdown, Modal, Offcanvas, Popover, ScrollSpy, Tab, Tooltip, Toast
//import {Collapse} from 'bootstrap';

//require('./utilities/class_enlarge.js');
//require('./utilities/class_count.js');
//require('./utilities/pdw_mobile_menu.js');
//require('./utilities/pdw_drilldown_menu.js');
//require('./utilities/pdw_carousel.js');
//require('./utilities/pdw_hide_link.js');
//require('./utilities/pdw_scrolled.js');
//require('./utilities/pdw_lightbox.js');

import AOS from 'aos';
AOS.init({
    once: false,
    mirror: true,
    duration: 500,
    offset: 50,
    disableMutationObserver: false,
});

if (window.innerWidth < 768) {
    document.documentElement.setAttribute('data-aos-offset', '25');
}



// Google review remove branding
document.addEventListener('DOMContentLoaded', function () {
    const branding = document.querySelector('.review-widget_net .branding');
    if (branding) {
    branding.remove();
}
});



// Sticky bottom CTA
(function () {
    const bar = document.getElementById('walwood-sticky-bar');
    if (!bar) return;

    const SHOW_AFTER = 180; // px de scroll avant apparition

    function onScroll() {
        if (window.scrollY > SHOW_AFTER) {
            bar.classList.add('is-visible');
        } else {
            bar.classList.remove('is-visible');
        }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
})();